import React, { useMemo, useState } from "react";
import style from "./index.module.scss";
import Statics from "../Statics";
import Search from "../Search";
import StuList from "./components/StuList";
import { StuVoteItem } from "service/vote";
import _ from "underscore";
import useQuery from "utils/useQuery";

interface VoteStuListProps {
    data: StuVoteItem[];
}

export default function VoteStuList({ data }: VoteStuListProps) {
    const { status } = useQuery<{ status: string }>();
    const [searchText, setSearchText] = useState("");
    const [filterStatus, setFilterStatus] = useState(status || "all");

    const filteredList = useMemo(() => {
        return data
            .filter(
                item =>
                    item.name?.indexOf(searchText) !== -1 ||
                    item.studentNo === searchText
            )
            .filter(item => {
                // 投票状态
                if (filterStatus === "all") return true;
                if (filterStatus === "vote" && item.voteStatus === "1")
                    return true;
                return filterStatus === "unVote" && item.voteStatus === "0";
            });
    }, [searchText, filterStatus, data]);

    // 统计数据
    const statics = useMemo(() => {
        return _.reduce(
            data,
            (memo, item) => ({
                courseStuCount: memo.courseStuCount + 1,
                voteStuCount:
                    memo.voteStuCount + (item.voteStatus === "1" ? 1 : 0),
                notVoteStuCount:
                    memo.notVoteStuCount + (item.voteStatus === "0" ? 1 : 0)
            }),
            { courseStuCount: 0, voteStuCount: 0, notVoteStuCount: 0 }
        );
    }, [data]);

    return (
        <div className={style.root}>
            <Statics
                {...statics}
                current={filterStatus}
                onChange={setFilterStatus}
            />
            <Search onChange={setSearchText} className={style.search} />
            <StuList data={filteredList} />
        </div>
    );
}
